const ContactInfo = () => (
  <div className="space-y-8">
    {/* Intro */}
    <div>
      <div className="inline-flex items-center gap-2 mb-4">
        <span className="h-px w-6 bg-brand-coral" />
        <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Nous contacter</span>
      </div>
      <h2 className="font-serif text-3xl lg:text-4xl text-brand-anthracite leading-tight mb-4">
        Parlons de votre <em>projet</em>
      </h2>
      <p className="text-brand-gray leading-relaxed">
        Chaque grand projet commence par une conversation. Remplissez le formulaire et Ashley vous recontactera dans les <strong>24–48h ouvrées</strong> pour organiser votre consultation.
      </p>
    </div>

    {/* Contact details */}
    <div className="space-y-4">
      {[
        {
          icon: 'ri-mail-line',
          label: 'Email',
          value: 'hello@evcodesign-ci.com',
          href: 'mailto:hello@evcodesign-ci.com',
          color: 'text-brand-fuchsia',
          bg: 'bg-brand-fuchsia/10',
        },
        {
          icon: 'ri-phone-line',
          label: 'Téléphone / WhatsApp',
          value: '+225 07 18 62 47 06',
          href: 'tel:+2250718624706',
          color: 'text-brand-coral',
          bg: 'bg-brand-coral/10',
        },
        {
          icon: 'ri-instagram-line',
          label: 'Instagram',
          value: '@evcodesign.ci',
          href: 'https://www.instagram.com/evcodesign.ci?igsh=emZmeWx2NXdmMmw1&utm_source=qr',
          color: 'text-brand-fuchsia',
          bg: 'bg-brand-fuchsia/10',
        },
        {
          icon: 'ri-map-pin-line',
          label: 'Localisation',
          value: 'Cocody, Riviera 4, Abidjan, Côte d\'Ivoire',
          href: '#',
          color: 'text-brand-coral',
          bg: 'bg-brand-coral/10',
        },
      ].map((item) => (
        <a
          key={item.label}
          href={item.href}
          className="flex items-center gap-4 p-4 bg-white rounded-xl hover:bg-brand-beige transition-colors duration-200 cursor-pointer group"
        >
          <div className={`w-10 h-10 shrink-0 flex items-center justify-center rounded-full ${item.bg}`}>
            <i className={`${item.icon} ${item.color} text-lg`} />
          </div>
          <div>
            <p className="text-xs text-brand-gray mb-0.5">{item.label}</p>
            <p className="text-sm font-medium text-brand-anthracite group-hover:text-brand-fuchsia transition-colors">{item.value}</p>
          </div>
        </a>
      ))}
    </div>

    {/* Business hours */}
    <div className="bg-white rounded-2xl p-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-time-line text-brand-coral text-base" />
        </div>
        <h4 className="text-brand-anthracite font-semibold text-sm">Heures d&apos;ouverture</h4>
      </div>
      <div className="space-y-2 text-sm">
        {[
          { day: 'Lundi – Vendredi', hours: '9h00 – 18h30' },
          { day: 'Samedi', hours: '9h00 – 13h00' },
          { day: 'Dimanche', hours: 'Fermé' },
        ].map((row) => (
          <div key={row.day} className="flex justify-between items-center py-1 border-b border-gray-100 last:border-0">
            <span className="text-brand-gray">{row.day}</span>
            <span className={`font-medium ${row.hours === 'Fermé' ? 'text-red-400' : 'text-brand-anthracite'}`}>{row.hours}</span>
          </div>
        ))}
      </div>
    </div>

    {/* Consultation note */}
    <div
      className="rounded-2xl p-6 text-white"
      style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
    >
      <div className="flex items-center gap-2 mb-3">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-star-line text-white text-base" />
        </div>
        <h4 className="font-semibold text-sm">Consultation initiale</h4>
      </div>
      <p className="text-white/90 text-sm leading-relaxed mb-2">
        Une consultation préalable de <strong>20 000 XOF</strong> est requise pour tout projet. Elle comprend l&apos;analyse de votre projet et un plan d&apos;action personnalisé.
      </p>
      <p className="text-white/75 text-xs">
        Ce montant est entièrement déduit si votre projet est confirmé.
      </p>
    </div>
  </div>
);

export default ContactInfo;
